import React, { memo } from "react";
import { Icon, IconProps } from "@chakra-ui/icon";

const TagIcon = (props: IconProps) => (
  <Icon width="16px" height="16px" viewBox="0 0 16 16" {...props}>
    <path d="M13.333 6.667V5.333h-2.666V2.667H9.333v2.666H6.667V2.667H5.333v2.666H2.667v1.334h2.666v2.666H2.667v1.334h2.666v2.666h1.334v-2.666h2.666v2.666h1.334v-2.666h2.666V9.333h-2.666V6.667h2.666Zm-4 2.666H6.667V6.667h2.666v2.666Z" />
  </Icon>
);

export default memo(TagIcon);
